var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items && _vm.items.length
    ? _c("div", { staticClass: "px-ogs mb-14" }, [
        _c(
          "div",
          { staticClass: "max-w-4xl mx-auto border-b border-grey" },
          _vm._l(_vm.items, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "border-t border-grey" },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "flex items-center justify-between w-full text-left leading-snug py-7 pr-2 focus:outline-none group",
                    on: {
                      click: function ($event) {
                        _vm.activeItem = _vm.activeItem === index ? null : index
                      },
                    },
                  },
                  [
                    _c(
                      "h4",
                      {
                        staticClass:
                          "group-hover:opacity-100 transition-opacity duration-200 pr-10",
                        class: {
                          "font-semibold": _vm.activeItem === index,
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.heading) + "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-shrink-0 w-5 h-5 transition-transform duration-200",
                        style: {
                          transform:
                            _vm.activeItem === index
                              ? "rotate(135deg)"
                              : "rotate(0)",
                        },
                      },
                      [_c("IconAdd")],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.activeItem === index
                  ? _c("div", { staticClass: "pb-7 pr-10" }, [
                      _c("div", {
                        staticClass: "rte",
                        domProps: { innerHTML: _vm._s(item.body) },
                      }),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }